import { render, staticRenderFns } from "./GuideItemCondensed.vue?vue&type=template&id=010e988d&scoped=true"
import script from "./GuideItemCondensed.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideItemCondensed.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideItemCondensed.vue?vue&type=style&index=0&id=010e988d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e988d",
  null
  
)

export default component.exports